const { z } = require("../zod-setup");
const { sanitizeDate } = require("../common");

const ClientContractStatus = {
    ACTIVE: "active",
    EXPIRED: "expired",
    CANCELED: "canceled",
    SUSPENDED: "suspended",
    PENDING: "pending"
};

const ClientContractSchema = z.object({
    idClient: z.string().min(1, "ID do cliente é obrigatório"),
    idContract: z.string().nullable().optional(), // Template ID
    idSale: z.string().nullable().optional(),
    idSaleItem: z.string().nullable().optional(),

    contractTitle: z.string().default("Contrato"),
    contractCode: z.string().nullable().optional(),

    status: z.nativeEnum(ClientContractStatus).default(ClientContractStatus.ACTIVE),

    startDate: z.string().or(z.date()).transform(val => sanitizeDate(val)),
    endDate: z.string().or(z.date()).nullable().optional().transform(val => val ? sanitizeDate(val) : null),

    // Enrollment Rules (Snapshot)
    requiresEnrollment: z.boolean().default(false),
    maxWeeklyEnrollments: z.number().min(0).default(0),
    allowedWeekDays: z.array(z.number().min(0).max(6)).default([]),
    enrollmentStatus: z.string().default("pending"),

    // Suspension Rules (Snapshot)
    allowSuspension: z.boolean().default(false),
    suspensionMaxDays: z.number().min(0).default(0),
    totalSuspendedDays: z.number().min(0).default(0),
    pendingSuspensionDays: z.number().min(0).default(0),

    // Cancellation
    minPeriodStayMembership: z.number().min(0).default(0),

    // Display / Utils
    billing: z.string().optional(),
    balanceDays: z.number().default(0),
    notes: z.string().optional()
});

const buildClientContractPayload = (data) => {
    return {
        // Core Links
        idClient: data.idClient || null,
        idContract: data.idContract || null, // Template ID
        idSale: data.idSale || null,
        idSaleItem: data.idSaleItem || null,

        // Copy of Template Data (Snapshot)
        contractTitle: data.contractTitle || data.title || "",
        contractCode: data.contractCode || null, // Generated by backend usually

        // Status & Dates (Specific to this instance)
        status: data.status || ClientContractStatus.ACTIVE,
        startDate: sanitizeDate(data.startDate) || sanitizeDate(new Date()),
        endDate: data.endDate ? sanitizeDate(data.endDate) : null, // Can be null if recurring infinite

        // Enrollment Rules (Snapshot)
        requiresEnrollment: Boolean(data.requiresEnrollment),
        maxWeeklyEnrollments: Number(data.maxWeeklyEnrollments || 0),
        allowedWeekDays: Array.isArray(data.allowedWeekDays) ? data.allowedWeekDays : [],
        enrollmentStatus: data.enrollmentStatus || "pending",

        // Suspension Rules (Snapshot)
        allowSuspension: Boolean(data.allowSuspension),
        suspensionMaxDays: Number(data.suspensionMaxDays || 0),
        totalSuspendedDays: Number(data.totalSuspendedDays || 0),
        pendingSuspensionDays: Number(data.pendingSuspensionDays || 0),

        // Cancellation (If applicable)
        minPeriodStayMembership: Number(data.minPeriodStayMembership || 0),

        // Display / Utils
        billing: data.billing || "--",
        balanceDays: Number(data.balanceDays ?? data.daysBalance ?? 0),

        notes: data.notes || "",
    };
};

module.exports = {
    ClientContractStatus,
    ClientContractSchema,
    buildClientContractPayload
};
